var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-04856cdc\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./RedDot.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/RedDot.vue
// module id = 1452
// module chunks = 159